<template>
  <div class="nav">
    <ul>
	    <li class="listPersonnel">人员管理</li>
      <li class="listHousing" @click="chose(1)">房源管理</li>
			<div class="menu-div" v-show="show == 1">
				<h5 @click="menu1">按户型</h5>
				<h5 @click="menu2">按类别</h5>
			</div>
    	<li class="listBa" @click="chose(2)">业务申请</li>
    		<div class="menu-div" v-show="show == 2">
    			<h5 @click="menu3">入住单申请</h5>
    			<h5 @click="menu4">退宿单申请</h5>
    			<h5 @click="menu5">调宿单申请</h5>
    		</div>
    	<li class="listBm" @click="chose(3)">业务办理</li>
    		<div class="menu-div" v-show="show == 3">
    			<h5>入住办理</h5>
    			<h5>退宿办理</h5>
    			<h5>调宿办理</h5>
    			<h5>物品领还记录</h5>
    		</div>
    	<li class="listSpotcheck" @click="chose(4)">点检管理(规划中)</li>
    	<li class="listRepair" @click="chose(5)">维修管理(规划中)</li>
    	<li class="listReport" @click="chose(6)">统计报表</li>
    		<div class="menu-div" v-show="show == 6">
    			<h5>入住统计</h5>
    			<h5>入住明细</h5>
    			<h5>入住历史</h5>
    		</div>
    </ul>
  </div>
  
</template>

<script>

  export default {


	  data() {
	     return {
        show:0

	    }
	  },
	  methods:{
      chose(t){
        this.show = t
        alert(t)
      },
	  },
}
</script>



// WEBPACK FOOTER //
// src/components/main/ceshi.vue